import { SamplingClassification } from '../../../../shared/types/notes/notes';

/**
 * Area-weighted average of classification damages.
 * Excludes unclassified cards (not in this array), classifications with
 * exclude_claim_calculation === true, and zones without linked samples
 * (API may send 0% — treat as no data, same as mobile "—").
 * Result rounded to 1 decimal.
 */
export function calculateClaimPercentDamage(
  classifications: SamplingClassification[]
): number | null {
  const eligible = (classifications || []).filter(
    classification => !classification.exclude_claim_calculation
  );

  let totalArea = 0;
  let weightedValue = 0;

  for (const classification of eligible) {
    const area =
      classification.area !== null && classification.area !== undefined
        ? classification.area
        : 0;
    const samplingsLen = (classification.samplings || []).length;
    if (!Number.isFinite(area) || area <= 0) {
      continue;
    }

    // No linked samples → no computed damage (API may send 0); exclude like mobile "—"
    if (samplingsLen === 0) {
      continue;
    }

    const damage = classification.calculated_percent_damage;
    if (damage === null || damage === undefined || !Number.isFinite(damage)) {
      continue;
    }

    totalArea += area;
    weightedValue += damage * area;
  }

  if (totalArea <= 0) {
    return null;
  }

  const raw = weightedValue / totalArea;
  return Math.round(raw * 10) / 10;
}
